import script from "./ChatListItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChatListItem.vue?vue&type=script&lang=ts&setup=true"

import "./ChatListItem.vue?vue&type=style&index=0&id=6deb831c&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6deb831c"]])

export default __exports__